import template from './ad-communication-type.jade';
import { REGIONS_FORMS_COMMUNICATION } from '../../../../../shared/constants';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {},
    controller(addFormService, $rootScope) {
      'ngInject';

      this.isEnabled = REGIONS_FORMS_COMMUNICATION.includes(addFormService.ad?.geo?.address?.[0]?.id);

      this.changeCommunicationType = preferredCommunicationType => {
        addFormService.ad.communication = {
          preferredCommunicationType,
        };
      };

      this.getCommunicationType = () => {
        return addFormService.ad.communication?.preferredCommunicationType;
      };

      $rootScope.$watch(
        () => addFormService.ad?.geo?.address?.[0]?.id,
        id => {
          this.isEnabled = REGIONS_FORMS_COMMUNICATION.includes(id);
          const needResetCommunication = id && !REGIONS_FORMS_COMMUNICATION.includes(id);
          if (needResetCommunication) {
            addFormService.ad.communication = undefined;
          }
        },
        true,
      );
    },
    controllerAs: 'adCommunicationTypeCtrl',
    replace: true,
  };
};
